<script lang="ts">
		export let dark = false;
</script>

<div class="wrapper" class:dark>
	<div class="gradient title-fake"></div>
	<div class="top-data-fake">
		<div class="mobile-stat">
			<div class="wrap">
				<div class="gradient stats-description"></div>
				<div class="gradient stats-value"></div>
			</div>
			<div class="wrap">
				<div class="gradient stats-description"></div>
				<div class="gradient stats-value"></div>
			</div>
		</div>
		<div class="stats-tablet">
			<div class="stats-block-fake">
				<div class="gradient stats-fake"></div>
				<div class="gradient stats-fake"></div>
				<div class="gradient stats-fake"></div>
			</div>
			<div class="gradient commits"></div>
		</div>
		<div class="gradient plate-fake"></div>
		<div class="gradient commits-fake tablet"></div>

		<div class="bottom-data-fake">
			<div class="gradient data-fake"></div>
			<div class="gradient data-fake"></div>
			<div class="gradient data-fake"></div>
		</div>
	</div>
</div>

<style lang="scss">
	@import 'githubLoader';
</style>
